<template>
    <div id="app">

    <vs-row vs-type="flex" vs-justify="space-between" >
      <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="3">
        <vs-button @click="newEvent" color="primary" type="filled">+ Evento</vs-button>
      </vs-col>
    </vs-row>

    <br/>
    <vs-popup  :active.sync="showModal" :title="title" @close="closepop" fullscreen>
        <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Nome</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                    <vs-input class="w-full" name="nome" v-model="rowSelected.name" v-validate="'required'" autocomplete="off" />
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('nome')">{{ errors.first('nome') }}</span>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Descrição</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="7">
                        <vs-textarea v-model="rowSelected.description"/>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Tipo</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="8">
                        <v-select
                            class="selectWidth200"
                            v-model="rowSelected.event_type_id"
                            v-validate="'required'"
                            name="tipo"
                            label="name"
                            :clearable="false"
                            :options="tiposEventovg"
                        >

                        </v-select>
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('tipo')">{{ errors.first('tipo') }}</span>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Categoria</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="8">
                        <v-select
                            class="selectWidth300"
                            v-model="rowSelected.event_category_id"
                            v-validate="'required'"
                            name="category"
                            label="name"
                            :clearable="false"
                            :options="categoriesEventsList"
                        >

                        </v-select>
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('category')">{{ errors.first('category') }}</span>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Preparação</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="8">
                        <flat-pickr :config="configdateTimePicker" v-validate="'required'"  name="prepraracao" placeholder="HH:MM"
                            v-model="rowSelected.preparation_time" />
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('prepraracao')">{{ errors.first('prepraracao') }}</span>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Duração</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="8">
                        <flat-pickr :config="configdateTimePicker" v-validate="'required'"  name="duracao" placeholder="HH:MM"
                            v-model="rowSelected.duration" />
                    </vs-col>
                </div>

                <div class="vx-row mb-2">
                <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('duracao')">{{ errors.first('duracao') }}</span>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Artigo</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="inline" vs-justify="left" vs-align="center" vs-w="7">
                        <vue-simple-suggest
                            v-model="rowSelected.item_id"
                            :list="getList"
                            :max-suggestions="10"
                            :min-length="3"
                            :debounce="500"
                            :filter-by-query="false"
                            :prevent-submit="true"
                            :mode="mode"
                            :nullable-select="true"
                            ref="suggestComponent"
                            value-attribute="id"
                            display-attribute="name"
                            @select="onSuggestSelect"
                            @input="clearInput"
                            name="artigo"
                            autocomplete="off"
                        >
                        </vue-simple-suggest>
                    </vs-col>
                    <vs-col vs-offset="3" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Preço</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
                        <vs-input class="w-full" name="price" v-validate="validationPrice" v-model="rowSelected.price" type="number" step="0.01"/>
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>
                    </vs-col>
                </div>

                <br/>

                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Nº Pessoas</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
                        <vs-input class="w-full" name="n_pax" v-validate="'required|integer|min_value:1'" v-model="rowSelected.n_pax"/>
                    </vs-col>
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('n_pax')">{{ errors.first('n_pax') }}</span>
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Para Crianças</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="1">
                        <vs-checkbox v-model="rowSelected.flg_children" class="mr-5"></vs-checkbox>
                    </vs-col>
                </div>

                <div class="vx-row mb-2">
                <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                    </vs-col>
                </div>

                <br/>
                <div class="vx-row mb-2">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="2">
                        <h5>Estado</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="inline" vs-justify="left" vs-align="center" vs-w="7">
                        <vs-radio v-model="rowSelected.status" vs-value="1" color="primary"
                            v-validate="'required'"
                            name="estado"
                        >
                            Activo
                        </vs-radio>
                        &nbsp;&nbsp;&nbsp;
                        <vs-radio v-model="rowSelected.status" vs-value="0" color="danger"
                                v-validate="'required'"
                            name="estado"
                        >
                            Inactivo
                        </vs-radio>
                    </vs-col>
                </div>

                <div class="vx-row mb-2">
                    <vs-col vs-offset="2" vs-type="flex" vs-justify="left" vs-align="center" vs-w="9">
                        <span class="text-danger text-sm" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                    </vs-col>
                </div>

                <br/>
                <vs-row vs-type="flex" vs-justify="center">
                    <vs-button v-if="displayNew" @click="addEvento()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Novo</vs-button>
                    <vs-button v-if="displayEdit" @click="editEvento()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Gravar</vs-button>
                    <vs-button color="warning" type="border" class="mb-2"
                        @click="clearFields"
                        icon-pack="feather" icon="icon-delete"
                    >
                        Limpar
                    </vs-button>
                </vs-row>

            </vs-col>
        </vs-row>
    </vs-popup>

    <vs-table
        v-model="selectedEvento"
        pagination
        max-items="10"
        search
        noDataText="Não foram encontrados registos"
        @selected="handleEvento"
        :data="eventosSpa"
        :stripe="true"
    >
        <template slot="header">
            <h3>
            Lista de Eventos
            </h3>
        </template>

        <template slot="thead">
            <vs-th>
            </vs-th>
            <vs-th>
                Evento
            </vs-th>
            <vs-th>
                Tipo
            </vs-th>
            <vs-th>
                Tempo Preparação
            </vs-th>
            <vs-th>
                Duração
            </vs-th>
            <vs-th>
                Estado
            </vs-th>

        </template>

        <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="indextr % 2 == 0 ?'primary':indextr == 668?'danger':null">
                <vs-td :data="data[indextr].name">
                </vs-td>

                <vs-td :data="data[indextr].name">
                    {{data[indextr].name}}
                </vs-td>

                <vs-td :data="data[indextr].event_type_id.name">
                    {{data[indextr].event_type_id.name}}
                </vs-td>

                <vs-td :data="data[indextr].preparation_time">
                    {{data[indextr].preparation_time}}
                </vs-td>

                <vs-td :data="data[indextr].duration">
                    {{data[indextr].duration}}
                </vs-td>

                <vs-td v-if="data[indextr].status == 0" :data="data[indextr].status">
                    Inactivo
                </vs-td>
                <vs-td v-if="data[indextr].status == 1" :data="data[indextr].status">
                    Activo
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>

    </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js';

import axios from 'axios';

import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';

import { Validator } from 'vee-validate';

const dict = {
  custom: {
    nome: {
        required: 'Campo Obrigatório ',
    },
    category: {
        required: 'Campo Obrigatório ',
    },
    prepraracao: {
        required: 'Campo Obrigatório ',
    },
    tipo: {
        required: 'Campo Obrigatório ',
    },
    duracao: {
        required: 'Campo Obrigatório ',
    },
    estado: {
        required: 'Campo Obrigatório ',
    },
    artigo: {
        required: 'Campo Obrigatório ',
    },
    artigo1: {
        required: 'Campo Obrigatório ',
    },
    n_pax: {
        required: 'Campo Obrigatório ',
        integer: 'O valor tem de ser númerico.',
        min_value: 'O valor tem de ser no mínimo 1.',
    },
    price: {
        required: 'Campo obrigatório, não existe Artigo associado.',
        decimal: 'O valor tem de ser númerico.'
    },
  }
};

Validator.localize('pt', dict);

export default{
    name: 'evento',
    data: function() {
        return {
            configdateTimePicker: {
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                time_24hr: true,
                defaultHour	: '00',
            },

            nome:   '',
            descricao:  '',
            tipo:   '',
            duracao:    '',
            preco:  '',
            n_pax: 1,
            flg_children: false,
            spa:    '',
            estado: '',
            artigo: '',
            tipos: [ ],
            title: '',
            showModal: false,
            displayNew : false,
            displayEdit : false,
            enableItem : true,
            selectedEvento: {},
            rowSelected:
            {
                item_id: '',
            },
            eventosSpa: [],
            mode: 'select',
            categoriesEventsList: [],
        }
    },

    components: {
        'v-select': vSelect,
        flatPickr,
        VueSimpleSuggest,
    },

    methods: {
        clearInput(){
            if(this.$refs.suggestComponent.text === '')
            {
                this.rowSelected.temp_item_id = '';
                this.rowSelected.item_id = '';
                this.rowSelected.item_name = '';
            }
        },

        handleEvento(tr) {
            this.title ='Editar Evento';

            let that = this;

            this.rowSelected = JSON.parse(JSON.stringify(tr));

            this.rowSelected.temp_item_id = this.rowSelected.item_id;
            this.rowSelected.item_id = this.rowSelected.item_name;

            this.showModal = true;

            this.displayEdit = true;
            this.displayNew = false;

            if(this.categoriesEventsList.length == 0){
                this.getSpaEventsCategories();
            }
        },

        addEvento() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    let that = this;

                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/spa/new/event?token='+window.localStorage.getItem('usertoken'),
                        data: {
                            event: that.rowSelected
                        }
                    })
                    .then(function (response) {
                        if(response.status == 200) {

                            that.$vs.notify({title:'',text:'Registo inserido com sucesso',color:'#63C0BB',position:'top-center'})

                            that.showModal = false;

                            that.getSpaEventos();
                        }
                    })
                    .catch(function (error){
                        console.log(error.response);
                    });
                }
            });
        },

        editEvento(){
            let that = this;

            axios({
                method: 'put',
                url: themeConfig.apiurl + '/spa/modify/event/' + this.rowSelected.event_id,
                data: {
                    event: that.rowSelected,
                    token: window.localStorage.getItem('usertoken'),
                }
            }).then(function (response) {
                if(response.status == 200){

                    that.$vs.notify({title:'', text:'Registo modificado com sucesso', color:'#63C0BB', position:'top-center'})

                    that.showModal = false;

                    that.getSpaEventos();
                }
            }).catch(function (error){
                console.log(error.response);
            });
        },
        getSpaEventos(){
            let that = this;
            this.$vs.loading();
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/events?token='+window.localStorage.getItem('usertoken') ,
            })
            .then(function (res) {
                if(res.status == 200) {
                    that.eventosSpa=res.data;

                    that.$store.dispatch('storeListEvents',res.data);

                }
            }).catch( function (err) {
                console.log(err);
            }).then(function (res){
                that.$vs.loading.close();
            });
        },

        getSpaEventsCategories(){
            let that = this;
            this.$vs.loading();
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/category/list?token='+window.localStorage.getItem('usertoken') ,
            })
            .then(function (res)
            {
                if(res.status == 200)
                {
                    that.categoriesEventsList = res.data;

                }
            }).catch( function (err) {
                console.log(err);
            }).then(function (res){
                that.$vs.loading.close();
            });
        },

        newEvent() {
            this.title = 'Adicionar Evento';

            this.displayNew = true;
            this.displayEdit = false;

            // this.errors.items = [];

            this.showModal = true;

            if(this.categoriesEventsList.length == 0){
                this.getSpaEventsCategories();
            }
        },

        closepop(){
            if(this.$validator.errors.items.length > 0)
            {
                while(this.$validator.errors.items.length > 0)
                {
                    this.$validator.errors.items.pop();

                }
            }



            this.showModal = false;
        },

        clearFields(){
            Object.keys(this.rowSelected).forEach(k =>  this.rowSelected[k] = '');
            this.rowSelected.preparation_time = '00:00';
            this.rowSelected.duration = '00:00';
        },

        getList(inputValue){
            let that = this;

            this.$vs.loading();

            return new Promise((resolve, reject) => {
                let url = themeConfig.apiurl + '/spa/event/item?item=' + inputValue+'&token='+window.localStorage.getItem('usertoken');
                fetch(url).then(response => {
                    if (!response.ok) {
                        reject()
                        that.$vs.loading.close();
                    }

                    response.json()
                    .then(json => {
                        resolve(json)

                        that.$vs.loading.close();
                    }).catch(e => {
                        reject(e)

                        that.$vs.loading.close();
                    })
                }).catch(error => {
                    this.loading = false
                    reject(error)
                    that.$vs.loading.close();
                })
            })
        },

        onSuggestSelect(suggest)
        {
            if(suggest != null)
            {
                this.selected = suggest;
                this.rowSelected.price = suggest.price;
            }
        },

        boldenSuggestion(scope) {
            if (!scope) return scope;
            const { suggestion, query } = scope;
            let result = this.$refs.suggestComponent.displayProperty(suggestion);
            if (!query) return result;
            const texts = query.split(/[\s-_/\\|.]/gm).filter(t => !!t) || [''];
            return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)','gi'), '$1<b>$2</b>$3');
        },
    },

    created() {
        this.$store.dispatch('getTiposEvento');

        this.getSpaEventos();

        if(this.$validator.errors.items.length > 0)
        {
            while(this.$validator.errors.items.length > 0)
            {
                this.$validator.errors.items.pop();
            }
        }
    },

    computed: {
        spasvg() {
            return this.$store.state.spasvg;
        },

        tiposEventovg(){
              return this.$store.state.tiposEventovg;
        },

        validationPrice() {
            return this.rowSelected.item_id
                ? 'decimal'
                : 'required|decimal';
        }
    },

    watch: {
        showModal(new_val,old_val) {
            if(!new_val){
                this.clearFields();
            }
        },

        rowSelected(new_val,old_val){
            if(typeof new_val.spa_id !== 'undefined'){
                this.enableItem = false;
            }
        },

        'rowSelected.item_id': function(new_val,old_val){
        },
    },
}

</script>

<style>

.custom2{
    padding-top: 5px;
}

/* Chrome, Safari, Edge */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
    appearance: textfield;
}

</style>